const localeLanguageAndCountryDelimiter = '_';
const defaultLanguageCode = 'en';

export function getLanguageFromLocale(locale: string = ''): string {
  const localeParts = locale?.split(localeLanguageAndCountryDelimiter);
  return localeParts.length === 2 ? localeParts[0].toLowerCase() : defaultLanguageCode;
}
